import type { Locale } from "../i18n.js";

const zh = {
  home: "首页",
  record: "战绩",
  social: "好友",
  me: "我的",
  notifications: "通知",
  currentActivity: "当前活动",
  startGame: "开始游戏",
  startMatching: "开始匹配",
  returnTable: "返回牌桌",
  continueReady: "继续准备",
  continueParty: "继续组队",
  matching: "正在匹配",
  waited: "已等待",
  autoFill: "匹配后将自动补足空位",
  cancelMatch: "取消匹配",
  setup: "比赛设置",
  solo: "单排匹配",
  duo: "邀请队友",
  privateRoom: "私人房",
  create: "创建",
  enterCode: "输入房间码",
  createRoomTab: "创建房间",
  joinRoomTab: "加入房间",
  tableSummary: "牌桌摘要",
  freeEntry: "免费",
  potentialResult: "胜负金币",
  roomVisibility: "房间权限",
  privateAccess: "凭房间码加入",
  joinRoomHint: "输入好友分享的房间码即可加入。",
  daily: "每日奖励",
  dailyDeal: "每日一牌",
  dailyDealHint: "今天全世界都打这副牌。每天一次。",
  dailyPlay: "开始今天这副",
  dailyResume: "继续这副牌",
  dailyDone: "今天已经打过了",
  dailyNext: "明天换新牌",
  dailyWon: "赢了这副",
  dailyLost: "输了这副",
  dailyAborted: "已中止，不计胜负",
  dailyPlace: "第 {position} 个走完",
  dailyRank: "今日第 {rank} 名，共 {players} 人",
  dailyBoard: "今日排名",
  dailyNobody: "今天还没有人打完。",
  guestKeepTitle: "保存这个账号",
  guestKeepHint: "绑定邮箱后，等级和对局记录都会留下。",
  guestKeepCta: "去绑定",
  claim: "领取",
  weeklyMission: "本周对局任务",
  weeklyProgress: "已完成 {count} / 8 场有效对局",
  weeklyFirst: "下一档 3 场 · 30 金币",
  weeklySecond: "下一档 8 场 · 70 金币",
  resetsIn: "{value}后重置",
  weeklyAllDone: "本周奖励已领完",
  live: "热门公开牌桌",
  tutorial: "新手进度",
  watchAll: "查看全部",
  ranked: "排位赛",
  gold: "金币赛",
  rules: "规则",
  stake: "金币档位",
  confirmMatch: "确认并匹配",
  overview: "概览",
  playStats: "出牌表现",
  competitionStats: "竞技表现",
  economyStats: "收益",
  couldNotLoad: "暂时无法加载内容",
  matches: "对局",
  seasonProgress: "赛季进度",
  recentTrend: "近期趋势",
  matchHistory: "历史对局",
  all: "全部",
  wins: "胜",
  losses: "负",
  playNow: "去开始比赛",
  feed: "动态",
  relations: "关系",
  friends: "好友",
  following: "关注",
  followers: "粉丝",
  findPlayer: "查找玩家",
  profile: "资料",
  settings: "设置",
  account: "账号",
  accessibility: "无障碍",
  reduceMotion: "减少动态效果",
  coaching: "教学提示",
  security: "账号安全",
  ruleCenter: "规则与牌型中心",
  signOut: "退出登录",
  party: "双排组队",
  inviteFriend: "邀请好友",
  startPartyMatch: "开始匹配",
  room: "准备房",
  publicWatch: "公开牌桌",
  ready: "准备",
  leave: "离开",
  share: "分享",
  watch: "公开观战",
  noLive: "暂无公开牌桌",
  noLiveHint: "比赛开始后，公开牌桌会出现在这里。",
  result: "比赛结算",
  rematch: "再来一局",
  backHome: "返回首页",
  offline: "网络已断开，恢复后会自动重连",
  loading: "正在恢复你的游戏状态…",
  retry: "重试",
  noActivity: "随时开一局",
  idleHint: "上次配置已为你保留，也可以在开始前调整。",
  copied: "已复制",
  dismiss: "关闭",
  save: "保存",
  profileSaved: "资料已保存",
  profileInvalid: "昵称或头像无效",
  profileSaveError: "资料保存失败，请重试",
  more: "更多操作",
  matchInProgress: "牌局进行中",
  autoPlaying: "系统托管中",
  waitingForYou: "等待你的操作",
  playersJoined: "位队友已加入",
  readyCheck: "匹配准备确认",
  roomCodeLabel: "房间码",
  fixedPartnerSeats: "固定搭档座位",
  privateRoomHint: "私人房仅支持金币赛，发牌前可关闭公开观战。",
  dailyReady: "今日奖励等待领取",
  standardGoldTable: "标准金币桌",
  liveScore: "第 3 局 · A队 5 / B队 4",
  tutorialNext: "下一步：认识级牌和红桃级牌",
  continue: "继续",
  modeLabel: "比赛模式",
  ratingSeason: "积分与赛季排名",
  goldReward: "金币奖励，不影响积分",
  rulesLabel: "规则",
  goldTier: "金币档位",
  requiredLevelBalance: "需等级 {level} · 余额 {coins}",
  winNet: "胜 +{coins}",
  lossNet: "负 -{coins}",
  locked: "未解锁",
  roomCodePlaceholder: "房间号",
  rankedFilter: "排位",
  goldFilter: "金币",
  currentRating: "当前积分",
  placementStatus: "定级进度 {count} / 10",
  establishedRating: "已完成定级",
  seasonResetNote: "每月按 75% 向 1000 分软重置",
  aheadNext: "领先下一名",
  combinedStats: "综合统计",
  winRate: "胜率",
  totalMatches: "总对局",
  bombCount: "炸弹",
  avgCoins: "场均金币",
  seasonBoard: "赛季榜单",
  rankPlayer: "排名 / 玩家",
  winsTotalRating: "胜/总局　积分",
  myPlayerCode: "我的玩家编号",
  copy: "复制",
  search: "搜索",
  noFeed: "还没有动态",
  noRelations: "还没有关系",
  relationHint: "查找玩家并互相关注后，就可以随时一起玩。",
  inMatch: "比赛中",
  inParty: "组队中",
  online: "在线",
  ratingSuffix: "积分",
  playTogether: "一起玩",
  moreAction: "更多",
  follow: "关注",
  changeAvatar: "更换",
  levelRating: "等级 {level} · {rating} 积分",
  friendCount: "{count} 好友",
  nickname: "昵称",
  playerId: "玩家编号",
  preferences: "偏好设置",
  language: "语言",
  languageHint: "界面显示语言",
  sound: "声音",
  soundHint: "牌桌、界面与提示音",
  reduceMotionHint: "减少牌桌和页面动画",
  rulesHint: "目标、牌型、升级与进贡",
  securityHint: "修改密码",
  chooseAvatar: "选择头像",
  ruleVariantsTitle: "三种规则",
  guideTitle: "入门指南",
  guideMinutes: "3 分钟上手",
  guideHeroTitle: "和对面的队友一起升级",
  guideHeroBody: "先出完手牌，帮助队伍率先过 A。",
  guideSeatsLabel: "四人对坐关系",
  guideYou: "你",
  guidePartner: "队友",
  guideRival: "对手",
  guidePartners: "对面是队友",
  guideThreeThings: "一局只记三件事",
  guideTeamTitle: "看队友",
  guideTeamBody: "对面的玩家和你同队",
  guideFinishTitle: "抢先出完",
  guideFinishBody: "先出完的队伍获得升级机会",
  guideUpgradeActionTitle: "一起升级",
  guideUpgradeActionBody: "越好的出牌顺序升得越快",
  guideCardsTitle: "看懂三种关键牌",
  guideLevelTitle: "级牌",
  guideLevelBody: "当前等级的点数，大于 A",
  guideWildTitle: "红桃级牌",
  guideWildBody: "可以代替需要的任意普通牌",
  guideBombTitle: "炸弹",
  guideBombBody: "四张起算炸弹，张数越多越大",
  guideUpgradePath: "出牌顺序决定升级",
  guideMore: "进贡与模式",
  guideDoubleWin: "双下",
  guideOneTwo: "一、二游同队",
  guideOneThree: "一、三游同队",
  guideWin: "率先完成过 A 即获胜",
  guideTributeTitle: "进贡与还贡",
  guideTributeBody: "开局时按提示交换牌，系统只会标出合法选择。",
  guideCasual: "休闲",
  guideCasualBody: "无进贡 · 适合练习",
  guideStandard: "标准",
  guideStandardBody: "完整进贡流程",
  guideCompetitive: "竞技",
  guideCompetitiveBody: "更严格的过 A 规则",
  guideStart: "开始一局",
  partyCode: "组队码",
  teammates: "队友",
  host: "房主",
  joined: "已加入",
  waitingTeammate: "等待队友",
  partyHint: "队友将固定为搭档座位。金币赛开始前会检查双方余额。",
  soloMeta: "单排",
  duoMeta: "固定队友",
  privateMeta: "金币赛 · 可观战",
  activeRooms: "活跃房间",
  noActiveRooms: "暂无活跃房间",
  noActiveRoomsHint: "公开牌桌开始后会显示在这里。",
  stepOne: "认识座位和队友",
  stepTwo: "学会看级牌",
  stepThree: "完成第一局",
  watchLoadError: "公开牌桌加载失败",
  refresh: "刷新",
  rulesStandard: "标准规则",
  inProgress: "进行中",
  playerHome: "玩家主页",
  publicWinRate: "胜率",
  publicMatches: "公开对局",
  recentPublic: "近期公开战绩",
  noPublic: "暂无公开战绩",
  publicHint: "只有玩家主动公开的内容会展示。",
  invitedPlay: "一起玩",
  watchTable: "观看牌桌",
  notificationsTitle: "通知",
  markAllRead: "全读",
  noNotifications: "暂无通知",
  notificationsHint: "邀请、关注和赛季提醒会出现在这里。",
  expiredInvite: "该邀请已过期",
  acceptInvite: "接受",
  declineInvite: "拒绝",
  inviteFailed: "出了点问题。",
  inviteSent: "组队邀请已发送",
  viewDetails: "点击查看详情",
  markRead: "已读",
  notificationGame: "游戏通知",
  inviteParty: "组队邀请",
  inviteLobby: "比赛邀请",
  inviteRematch: "再开一桌",
  newFollow: "新的关注",
  friendTable: "好友公开开桌",
  seasonReminder: "赛季提醒",
  reportPreparing: "详细战报仍在生成",
  reportPreparingHint: "比赛结果不会丢失，请稍后重试。",
  teamAWins: "A 队胜利",
  teamBWins: "B 队胜利",
  yourRewards: "你的奖励",
  coins: "金币",
  xpEarned: "经验",
  rating: "积分",
  xpBreakdown: "经验明细",
  participation: "参与率",
  baseXp: "原始经验",
  multiplier: "参与倍率",
  coinBreakdown: "金币明细",
  entry: "底注",
  payout: "返还",
  accountBonus: "账户奖励",
  eloBreakdown: "积分明细",
  baseElo: "基础变化",
  performanceCorrection: "表现修正",
  disconnectCorrection: "掉线修正",
  levelUpTitle: "升级奖励",
  levelUpBody: "升至 {level} 级，获得 {coins} 金币",
  levelUpCoins: "金币已到账",
  noTrend: "完成一场比赛后，这里会显示你的近期走势。",
  handsAndPlayers: "详细局数与四人表现",
  handsUnit: "局",
  minutesUnit: "分钟",
  watchReplay: "观看回放",
  shareReplay: "分享回放",
  shareResult: "分享战报",
  shareResultTitle: "我的掼蛋战报",
  shareResultText: "来看这场比赛的精彩回放。",
  shareResultHint: "生成可公开访问的回放链接。",
  shareDone: "已分享",
  winningTeam: "获胜队伍",
  youWon: "你赢了",
  matchComplete: "比赛结束",
  matchMeta: "{hands} 局 · {minutes} 分钟",
  matchHighlight: "本场高光",
  playersAtTable: "同桌玩家",
  addFriend: "加好友",
  friendRequestSent: "已关注",
  alreadyFriends: "已是好友",
  teamA: "A 队",
  teamB: "B 队",
  resultMvp: "MVP",
  resultController: "控场",
  resultBomber: "爆破手",
  resultSprinter: "冲线手",
  firstOuts: "头游",
  trickWins: "收墩",
  handHistory: "每局进程",
  handNumber: "第 {number} 局",
  player: "玩家",
  highlightBomb: "{name} 打出关键炸弹",
  highlightFirst: "{name} 抢下头游",
  highlightTeam: "{team} 队锁定胜局",
  highlightBombHint: "这手牌改变了桌上节奏。",
  highlightFinishHint: "出牌顺序直接决定本局升级。",
} as const;

const en: Record<keyof typeof zh, string> = {
  home: "Home",
  record: "Record",
  social: "Friends",
  me: "Me",
  notifications: "Notifications",
  currentActivity: "Current activity",
  startGame: "Start game",
  startMatching: "Start matching",
  returnTable: "Return to table",
  continueReady: "Continue ready check",
  continueParty: "Continue party",
  matching: "Matching",
  waited: "Waiting",
  autoFill: "Open seats are filled automatically",
  cancelMatch: "Cancel matching",
  setup: "Game setup",
  solo: "Solo match",
  duo: "Invite teammate",
  privateRoom: "Private room",
  create: "Create",
  enterCode: "Enter room code",
  createRoomTab: "Create room",
  joinRoomTab: "Join room",
  tableSummary: "Table summary",
  freeEntry: "Free",
  potentialResult: "Win / loss",
  roomVisibility: "Access",
  privateAccess: "Room code required",
  joinRoomHint: "Enter the room code shared by your friend.",
  daily: "Daily reward",
  dailyDeal: "Daily deal",
  dailyDealHint: "The same hand for everyone today. One go at it.",
  dailyPlay: "Play today's hand",
  dailyResume: "Back to your hand",
  dailyDone: "Played today",
  dailyNext: "A new hand tomorrow",
  dailyWon: "Won the hand",
  dailyLost: "Lost the hand",
  dailyAborted: "Aborted — no result",
  dailyPlace: "Out {position} of 4",
  dailyRank: "{rank} of {players} today",
  dailyBoard: "Today",
  dailyNobody: "Nobody has finished today's hand yet.",
  guestKeepTitle: "Keep this account",
  guestKeepHint: "Add an email and your level and match history stay with you.",
  guestKeepCta: "Add an email",
  claim: "Claim",
  weeklyMission: "Weekly match missions",
  weeklyProgress: "{count} / 8 valid matches completed",
  weeklyFirst: "Next: 3 matches · 30 coins",
  weeklySecond: "Next: 8 matches · 70 coins",
  resetsIn: "Resets in {value}",
  weeklyAllDone: "All weekly rewards claimed",
  live: "Popular live tables",
  tutorial: "Getting started",
  watchAll: "View all",
  ranked: "Ranked",
  gold: "Gold",
  rules: "Rules",
  stake: "Gold tier",
  confirmMatch: "Confirm and match",
  overview: "Overview",
  playStats: "Play",
  competitionStats: "Competition",
  economyStats: "Rewards",
  couldNotLoad: "Could not load this page",
  matches: "Matches",
  seasonProgress: "Season progress",
  recentTrend: "Recent trend",
  matchHistory: "Match history",
  all: "All",
  wins: "Wins",
  losses: "Losses",
  playNow: "Start a match",
  feed: "Feed",
  relations: "Relations",
  friends: "Friends",
  following: "Following",
  followers: "Followers",
  findPlayer: "Find a player",
  profile: "Profile",
  settings: "Settings",
  account: "Account",
  accessibility: "Accessibility",
  reduceMotion: "Reduce motion",
  coaching: "Coaching tips",
  security: "Account security",
  ruleCenter: "Rules and hands",
  signOut: "Sign out",
  party: "Duo party",
  inviteFriend: "Invite friend",
  startPartyMatch: "Start matching",
  room: "Ready room",
  publicWatch: "Live tables",
  ready: "Ready",
  leave: "Leave",
  share: "Share",
  watch: "Live tables",
  noLive: "No live tables",
  noLiveHint: "Public tables will appear here after play begins.",
  result: "Match result",
  rematch: "Play again",
  backHome: "Back home",
  offline: "You are offline. The game will reconnect automatically.",
  loading: "Restoring your game state…",
  retry: "Retry",
  noActivity: "Play whenever you like",
  idleHint: "Your last setup is saved and can be changed before matching.",
  copied: "Copied",
  dismiss: "Close",
  save: "Save",
  profileSaved: "Profile saved",
  profileInvalid: "The nickname or avatar is invalid",
  profileSaveError: "Could not save your profile. Try again",
  more: "More actions",
  matchInProgress: "Match in progress",
  autoPlaying: "Auto-playing",
  waitingForYou: "Waiting for you",
  playersJoined: "teammates joined",
  readyCheck: "Ready check",
  roomCodeLabel: "Room code",
  fixedPartnerSeats: "Fixed partner seats",
  privateRoomHint:
    "Private rooms are gold-only. Public spectating can be disabled before the deal.",
  dailyReady: "Today's reward is ready",
  standardGoldTable: "Standard gold table",
  liveScore: "Hand 3 · Team A 5 / Team B 4",
  tutorialNext: "Next: level cards and heart level cards",
  continue: "Continue",
  modeLabel: "Mode",
  ratingSeason: "Rating and season rank",
  goldReward: "Gold rewards, no rating change",
  rulesLabel: "Rules",
  goldTier: "Gold tier",
  requiredLevelBalance: "Level {level} · {coins} balance required",
  winNet: "Win +{coins}",
  lossNet: "Loss -{coins}",
  locked: "Locked",
  roomCodePlaceholder: "ROOM CODE",
  rankedFilter: "Ranked",
  goldFilter: "Gold",
  currentRating: "Current rating",
  placementStatus: "Placement {count} / 10",
  establishedRating: "Placement complete",
  seasonResetNote: "Monthly soft reset retains 75% from 1000",
  aheadNext: "Ahead of next player",
  combinedStats: "Combined stats",
  winRate: "Win rate",
  totalMatches: "Matches",
  bombCount: "Bombs",
  avgCoins: "Average coins",
  seasonBoard: "Season ladder",
  rankPlayer: "Rank / player",
  winsTotalRating: "W / total　Rating",
  myPlayerCode: "My player code",
  copy: "Copy",
  search: "Search",
  noFeed: "Nothing here yet",
  noRelations: "No relationships yet",
  relationHint: "Find players and follow each other to play together.",
  inMatch: "In a match",
  inParty: "In a party",
  online: "Online",
  ratingSuffix: "rating",
  playTogether: "Play together",
  moreAction: "More",
  follow: "Follow",
  changeAvatar: "Change",
  levelRating: "Level {level} · {rating} rating",
  friendCount: "{count} friends",
  nickname: "Display name",
  playerId: "Player code",
  preferences: "Preferences",
  language: "Language",
  languageHint: "Interface language",
  sound: "Sound",
  soundHint: "Table, interface and hint sounds",
  reduceMotionHint: "Reduce table and page animations",
  rulesHint: "Goals, hands, upgrades and tribute",
  securityHint: "Change password",
  chooseAvatar: "Choose avatar",
  ruleVariantsTitle: "Three rulesets",
  guideTitle: "Getting started",
  guideMinutes: "Learn in 3 minutes",
  guideHeroTitle: "Upgrade with your opposite partner",
  guideHeroBody: "Finish your cards and help your team pass A first.",
  guideSeatsLabel: "Four-player opposite seating",
  guideYou: "You",
  guidePartner: "Partner",
  guideRival: "Rival",
  guidePartners: "Opposite means partner",
  guideThreeThings: "Remember only three things",
  guideTeamTitle: "Find your partner",
  guideTeamBody: "The player opposite you is on your team",
  guideFinishTitle: "Finish first",
  guideFinishBody: "An early finish earns your team an upgrade",
  guideUpgradeActionTitle: "Upgrade together",
  guideUpgradeActionBody: "Better finishing positions move you faster",
  guideCardsTitle: "Know three key cards",
  guideLevelTitle: "Level card",
  guideLevelBody: "The current level rank, stronger than an ace",
  guideWildTitle: "Heart level card",
  guideWildBody: "Substitutes for any ordinary card you need",
  guideBombTitle: "Bomb",
  guideBombBody: "Four or more matching ranks; more cards means stronger",
  guideUpgradePath: "Finishing order sets the upgrade",
  guideMore: "Tribute and modes",
  guideDoubleWin: "Double down",
  guideOneTwo: "Partners finish 1st and 2nd",
  guideOneThree: "Partners finish 1st and 3rd",
  guideWin: "Be the first team to pass A",
  guideTributeTitle: "Tribute and return",
  guideTributeBody:
    "Exchange cards when prompted; only legal choices are highlighted.",
  guideCasual: "Casual",
  guideCasualBody: "No tribute · Learn freely",
  guideStandard: "Standard",
  guideStandardBody: "Complete tribute flow",
  guideCompetitive: "Competitive",
  guideCompetitiveBody: "Stricter rules for passing A",
  guideStart: "Start a match",
  partyCode: "Party code",
  teammates: "Teammates",
  host: "Host",
  joined: "Joined",
  waitingTeammate: "Waiting for a teammate",
  partyHint:
    "Partners keep their seats. Coin balances are checked before a gold match starts.",
  soloMeta: "Solo",
  duoMeta: "Fixed teammate",
  privateMeta: "Gold · Spectating on",
  activeRooms: "Active rooms",
  noActiveRooms: "No active rooms",
  noActiveRoomsHint: "Public tables appear here when play begins.",
  stepOne: "Meet seats and partners",
  stepTwo: "Learn level cards",
  stepThree: "Finish your first match",
  watchLoadError: "Could not load live tables",
  refresh: "Refresh",
  rulesStandard: "Standard rules",
  inProgress: "In progress",
  playerHome: "Player profile",
  publicWinRate: "Win rate",
  publicMatches: "Public matches",
  recentPublic: "Recent public results",
  noPublic: "No public results",
  publicHint: "Only content the player shares publicly is shown.",
  invitedPlay: "Play together",
  watchTable: "Watch table",
  notificationsTitle: "Notifications",
  markAllRead: "Mark all read",
  noNotifications: "No notifications",
  notificationsHint: "Invites, follows and season reminders appear here.",
  expiredInvite: "This invite has expired",
  acceptInvite: "Accept",
  declineInvite: "Decline",
  inviteFailed: "Something went wrong.",
  inviteSent: "Party invite sent",
  viewDetails: "View details",
  markRead: "Read",
  notificationGame: "Game notification",
  inviteParty: "Party invite",
  inviteLobby: "Match invite",
  inviteRematch: "Rematch invite",
  newFollow: "New follower",
  friendTable: "Friend opened a table",
  seasonReminder: "Season reminder",
  reportPreparing: "Your report is still being prepared",
  reportPreparingHint: "Your result is safe. Please try again shortly.",
  teamAWins: "Team A wins",
  teamBWins: "Team B wins",
  yourRewards: "Your rewards",
  coins: "Coins",
  xpEarned: "XP",
  rating: "Rating",
  xpBreakdown: "XP breakdown",
  participation: "Participation",
  baseXp: "Raw XP",
  multiplier: "Participation multiplier",
  coinBreakdown: "Coin breakdown",
  entry: "Entry",
  payout: "Payout",
  accountBonus: "Account rewards",
  eloBreakdown: "Rating breakdown",
  baseElo: "Base change",
  performanceCorrection: "Performance adjustment",
  disconnectCorrection: "Disconnect adjustment",
  levelUpTitle: "Level-up reward",
  levelUpBody: "Reached level {level} and earned {coins} coins",
  levelUpCoins: "Coins credited",
  noTrend: "Finish a match to see your recent trend here.",
  handsAndPlayers: "Hands and player performance",
  handsUnit: "hands",
  minutesUnit: "minutes",
  watchReplay: "Watch replay",
  shareReplay: "Share replay",
  shareResult: "Share result",
  shareResultTitle: "My Guandan result",
  shareResultText: "Watch the highlights and replay from this match.",
  shareResultHint: "Create a public link to this match replay.",
  shareDone: "Shared",
  winningTeam: "Winning team",
  youWon: "You won",
  matchComplete: "Match complete",
  matchMeta: "{hands} hands · {minutes} min",
  matchHighlight: "Match highlight",
  playersAtTable: "Players at the table",
  addFriend: "Add friend",
  friendRequestSent: "Following",
  alreadyFriends: "Friends",
  teamA: "Team A",
  teamB: "Team B",
  resultMvp: "MVP",
  resultController: "Controller",
  resultBomber: "Bomber",
  resultSprinter: "Sprinter",
  firstOuts: "First out",
  trickWins: "Tricks",
  handHistory: "Hand progression",
  handNumber: "Hand {number}",
  player: "Player",
  highlightBomb: "{name} played a key bomb",
  highlightFirst: "{name} finished first",
  highlightTeam: "Team {team} closed the match",
  highlightBombHint: "This play shifted the rhythm of the table.",
  highlightFinishHint: "Finishing order directly set the upgrade.",
};

export type MobileCopyKey = keyof typeof zh;
export function mobileCopy(
  locale: Locale,
  key: MobileCopyKey,
  params?: Record<string, string | number>,
): string {
  let text = locale === "zh-CN" ? zh[key] : en[key];
  for (const [name, value] of Object.entries(params ?? {}))
    text = text.replaceAll(`{${name}}`, String(value));
  return text;
}
